// extracted by mini-css-extract-plugin
export default {"footer-nav-container":"FooterNav_footer-nav-container__78RrI","footer-nav-link":"FooterNav_footer-nav-link__vq-Wz"};